var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"max-height":"20","max-width":"20","src":"/img/icons/gardeshhesab.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }